import {ActivityIndicator, Pressable, StyleSheet, Text} from 'react-native';
import {Color} from "@/lib/styles";
import {useState} from "react";
import Icon, {IconKind} from "@/lib/components/Icon";

type Props = {
    title?: string,
    color?: string,
    backgroundColor?: string,
    busy?: boolean,
    disabled?: boolean,
    height?: number,
    border?: boolean,
    // Set to true to make the button inverted, i.e. active as default.
    activated?: boolean,
    icon?: IconKind,
    onPress: () => any,
}

export default function ActionButton({
                                         title,
                                         icon,
                                         color,
                                         backgroundColor,
                                         border,
                                         busy,
                                         disabled,
                                         activated,
                                         height,
                                         onPress
                                     }: Props) {
    const [pressed, setPressed] = useState(false);
    const [hover, setHover] = useState(false);

    function selectFgColor() {
        if (busy) {
            return Color.Background;
        } else if (disabled) {
            return Color.Faded;
        } else if (pressed || activated) {
            return backgroundColor || Color.Background;
        } else if (color) {
            return color;
        }
        return Color.PrimaryText;
    }

    function selectBgColor() {
        if (busy) {
            return Color.Background;
        } else if (disabled) {
            return Color.BackgroundContainer;
        } else if (activated && pressed) {
            return Color.PrimaryText;
        } else if (activated) {
            return color || Color.PrimaryText;
        } else if (pressed && color) {
            return color;
        } else if (pressed) {
            return Color.PrimaryText;
        } else if (backgroundColor) {
            return backgroundColor;
        }
        return "transparent";
    }

    const isIconOnly = !!icon && !title;
    const isIconAndTitle = !!icon && !!title;
    const fgColor = selectFgColor();
    const bgColor = selectBgColor();
    const borderColor = activated ? bgColor : fgColor;
    const buttonWidthHeight = height || 42;
    const iconSize = (buttonWidthHeight) / 2;
    const paddingRight = isIconOnly ? 0 : (buttonWidthHeight - 10) / 2;
    const paddingLeft = isIconOnly ? 0 : (isIconAndTitle ? paddingRight - 1.5 : paddingRight);

    // noinspection JSSuspiciousNameCombination
    return (
        <Pressable
            style={[styles.button, {
                borderColor: borderColor,
                backgroundColor: bgColor,
                outlineColor: borderColor,
                outlineWidth: ((hover || activated) && !busy && !disabled) ? 1 : 0,
                width: !!height && !title ? height : "auto",
                height: buttonWidthHeight,
                minWidth: buttonWidthHeight,
                borderRadius: buttonWidthHeight * 2,
                borderWidth: border !== false ? 1 : 0,
                paddingLeft,
                paddingRight,
            }]}
            onPress={onPress}
            onPressIn={() => setPressed(true)}
            onPressOut={() => setPressed(false)}
            onHoverIn={() => setHover(true)}
            onHoverOut={() => setHover(false)}
            focusable={true}
            disabled={busy || disabled}
        >
            {icon && <Icon kind={icon} size={iconSize} color={fgColor}/>}
            {title && <Text style={[styles.buttonLabel, {color: fgColor}]} selectable={false}>{title}</Text>}
            {busy && <ActivityIndicator style={styles.spinner} color={color}></ActivityIndicator>}
        </Pressable>
    )
}

const styles = StyleSheet.create({
    button: {
        paddingHorizontal: 16,
        gap: 5.25,
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "row",
        outlineStyle: "solid",
        borderStyle: "solid",
        borderColor: Color.PrimaryText,
    },
    buttonLabel: {
        color: Color.PrimaryText,
        fontSize: 16,
    },
    spinner: {
        position: "absolute",
    },
});